<ag-grid-angular
  class="ag-theme-material h-100"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColumnDef"
  [gridOptions]="gridOptions"
  (gridReady)="onGridReady($event)"
/>

<ng-template #actionsTemplate let-row>
  <button type="button" [matMenuTriggerFor]="menu" [showMenuIcon]="false" andButton color="ghost" size="small">
    <anduin-icon name="more-horizontal" class="menu-icon" />
  </button>
  <mat-menu #menu="matMenu">
    <div [tooltipEnabled]="!canLaunchClientPortal" tooltip="You do not have permission to access the client portal">
      <button
        type="button"
        [disabled]="!canLaunchClientPortal"
        (click)="navigateToClientPortal(row.data.id)"
        andButton
        color="ghost"
        mat-menu-item
        size="small"
      >
        Go to client portal
      </button>
    </div>
  </mat-menu>
</ng-template>
